export const environment = {
    fe_url: 'https://staging.nutrigenic.co.uk/',
    baseUrl: 'https://staging-be.nutrigenic.co.uk/api/',
    enable_analytics: false,
    stripe_api_key: "pk_test_51ObncfDEFnXNw9y2bnMSZoIl3VwUHBKVvoZ4UZVk7wBFTSDEFCrcW2Gh05VIXfylB9YV2dBRqCGU0d43q1buytqy00RVf8vteK",
    stripe_customer_billing_details_update_url: "https://billing.stripe.com/p/login/test_7sY5kD1av4Xx06G5rf5sA00",

    recaptcha_site_key: '6LeQSyEsAAAAAHeaNuFJM8nx6LhXvVGQ06UTsuZP',

    apple_redirect_uri: 'https://staging.nutrigenic.co.uk/',
    apple_client_id: 'com.nutri.genic.client',

    google_client_id: '620303240033-gkvqo0ru5dclfcfmcvrgo9rasi8alfpo.apps.googleusercontent.com'
};
